import { LEARNER_ROUTES, LearnerRouteRecord } from './route-names';

const HeaderBar = () => import('@learner/components/HeaderBar.vue');

const defaultComponents = {
  HeaderBar,
};

const routes: LearnerRouteRecord[] = [
  {
    path: '/',
    name: LEARNER_ROUTES.home,
    meta: {
      requiresAuth: true,
      title: 'Home',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/Courses/Courses.vue'),
    },
  },
  {
    path: '/courses',
    name: LEARNER_ROUTES.courses,
    meta: {
      requiresAuth: true,
      title: 'Home',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/Courses/Courses.vue'),
    },
  },
  {
    path: '/profile',
    name: LEARNER_ROUTES.profile,
    meta: {
      requiresAuth: true,
      title: 'Update Profile',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/UpdateProfile.vue'),
    },
  },
  {
    path: '/login',
    name: LEARNER_ROUTES.login,
    meta: {
      lobby: true,
      title: 'Login',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/Login.vue'),
    },
  },
  {
    path: '/login/default',
    name: LEARNER_ROUTES.loginDefault,
    meta: {
      title: 'Login',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/LoginDefault.vue'),
    },
  },
  {
    path: '/logout',
    name: LEARNER_ROUTES.logout,
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/Logout.vue'),
    },
  },
  {
    path: '/reset-password',
    name: LEARNER_ROUTES.resetPassword,
    meta: {
      title: 'Reset Password',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/ResetPassword.vue'),
    },
  },
  {
    path: '/course/:id(\\d+)?',
    name: LEARNER_ROUTES.coursePlayer,
    meta: {
      bypassIf: (to: {query: {token: string}}) => to.query.token,
      requiresAuth: true,
      coursePageHeader: true,
      title: 'Course Player',
      showSplash: false,
    },
    components: {
      default: () => import('@learner/views/CoursePlayer.vue'),
    },
  },
  {
    path: '/course/error',
    name: LEARNER_ROUTES.courseError,
    meta: {
      title: 'Course Playback Error',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/CoursePlayerError.vue'),
    },
  },
  {
    path: '/login/error',
    name: LEARNER_ROUTES.loginError,
    meta: {
      title: 'Login Error',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/LoginError.vue'),
    },
  },
  {
    path: '/user/trial/registration',
    name: LEARNER_ROUTES.trialRegistration,
    meta: {
      title: 'Trial User Registration',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/TrialUserRegistration.vue'),
    },
  },
  {
    path: '/campaigns/unsubscribe',
    name: LEARNER_ROUTES.campaignsUnsubscribe,
    meta: {
      title: 'Unsubscribe Campaign',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/CampaignsUnsubscribe.vue'),
    },
  },
  {
    path: '/access-denied',
    name: LEARNER_ROUTES.accessDenied,
    meta: {
      title: 'Access denied',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/400View.vue'),
    },
  },
  {
    path: '/public/logout',
    name: LEARNER_ROUTES.publicLogout,
    meta: {
      title: 'Logout',
    },
    components: {
      ...defaultComponents,
      default: () => import('@learner/views/PublicLogout.vue'),
    },
  },

  // this must be last so it catches 404s
  {
    path: '/:pathMatch(.*)*',
    name: LEARNER_ROUTES.notFound,
    component: () => import('@learner/views/404.vue'),
  },
];

export default routes;
